<template>
  <div>
    <PageTitle :title="$t('global.team-permissions')">
      <template #actions>
        <Btn variant="primary" @click="createTeam">{{ $t("global.create-team") }}</Btn>
      </template>
    </PageTitle>
    <LoadingState v-if="loading()" />
    <Tab v-else :tabs="getTabs(teams)">
      <template v-for="(team, index) in teams" #[team.id]>
        <PermissionsTable
          :key="index"
          :team="team"
          :permissions="getPermissions(team)"
          :status="teamsStatus"
        />
      </template>
    </Tab>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import LoadingState from "@/components/display/LoadingState";
import PageTitle from "@/components/display/PageTitle";
import PermissionsTable from "@/components/smart/tables/PermissionsTable";
import store from "@/store";
import Tab from "@/components/display/Tab";
import TeamAddModal from "@/components/smart/modals/TeamAdd";

export default {
  name: "PermissionsPage",
  components: { Btn, LoadingState, PageTitle, Tab, PermissionsTable },
  setup() {
    const teams = computed(() => store.getters["team/getList"]);
    const teamsStatus = computed(() => store.getters["team/getListStatus"]);
    const resourceRoles = computed(() => store.getters["team/resourceRoles"]);
    const rolesStatus = computed(() => store.getters["team/rolesStatus"]);

    const getTabs = (teamList) => {
      if (!teamList) {
        return [];
      }

      return teamList.map((team) => ({
        name: team.id,
        label: team.name,
      }));
    };

    // only list resource permissions (there are 4 permission types that have to do with notifications or something)
    const getPermissions = (team) => {
      if (!resourceRoles.value) {
        return [];
      }

      return resourceRoles.value.map((role) => ({
        name: role.name,
        actions: team.permissions[role.name],
      }));
    };

    const createTeam = () => {
      store.dispatch("modals/open", {
        template: TeamAddModal,
      });
    };

    const loading = () => rolesStatus.value.isLoading || teamsStatus.value.isLoading;

    onMounted(() => {
      store.dispatch("team/getList").then(() => store.dispatch("team/getRoles"));
    });

    return { getTabs, getPermissions, teams, loading, teamsStatus, createTeam, resourceRoles };
  },
};
</script>
